import { Sport } from '__generated__/globalTypes';
import { useCurrentUserContext } from 'contexts/currentUser';

export const useSimplifiedNav = (sport: Sport) => {
  const { footballUserProfile } = useCurrentUserContext();

  return {
    showSimplifiedNav:
      sport === Sport.FOOTBALL &&
      !!footballUserProfile &&
      footballUserProfile.proUnlocked === false,
  };
};
